import makeStyles from '@mui/styles/makeStyles';

const wellnessRenewalChangeStyle = makeStyles(
  {
    ratesLabel: {
      fontSize: '24px',
      fontWeight: '800',
      lineHeight: '18px',
      letterSpacing: '0.15px',
      paddingBottom: '8px',
    },
    displayFlex: {
      display: 'flex',
    },
    radioGroupdDiv: {
      backgroundColor: '#FAFAFA',
      marginBottom: '45px',
      width: '100%',
      borderRadius: '24px',
      padding: '24px 30px',
    },
    tier: {
      fontWeight: 500,
      color: '#373F51',
      letterSpacing: '0.25px',
    },
    detailCardDiv: { display: 'flex', marginBottom: '24px' },
  },
  { name: 'wellness-renewal-change' }
);

export { wellnessRenewalChangeStyle };
